import React, { useState, useEffect, useRef } from "react";
import { Container, Nav, Navbar, Button, Dropdown } from "react-bootstrap";
import "./index.scss";
import logo from "../../../assets/images/Spot in.png";
import logo1 from "../../../assets/images/Spotinmobile.png";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../../../contexts/LanguageContext";
import { useTranslation } from "../../../hooks/useTranslation";

export default function Header() {
  const location = useLocation();
  const { language, toggleLanguage } = useLanguage();
  const { t } = useTranslation();
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const dropdownRef = useRef(null);

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowServicesDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="main-header">
      <Navbar expand="lg" className="navbar-transparent" variant="dark">
        <Container fluid>
          {/* LOGO */}
          <Navbar.Brand href="/" className="logo">
            {isMobile ? (
              <div className="mobile-logo">
                <div className="mobile-logo-icon"><img src={logo1} /></div>
              </div>
            ) : (
              <img src={logo} alt="Spot In Logo" />
            )}
          </Navbar.Brand>

          {/* Mobile Language Display */}
          {isMobile && (
            <div 
              className="mobile-language-display"
              onClick={toggleLanguage}
            >
              {language.toUpperCase()}
            </div>
          )}

          {/* Menu responsive toggle */}
          <Navbar.Toggle 
            aria-controls="basic-navbar-nav" 
            className={`mobile-burger ${showMobileMenu ? 'active' : ''}`}
            onClick={() => setShowMobileMenu(!showMobileMenu)}
          >
            <span></span>
            <span></span>
            <span></span>
          </Navbar.Toggle>

          {/* NAV LINKS */}
          <Navbar.Collapse
            id="basic-navbar-nav"
            className={`justify-content-end ${showMobileMenu ? 'show' : ''}`}>
            <Nav className="align-items-center">
              <Nav.Link
                href="/contact"
                className={location.pathname === "/contact" ? "active contact-active" : ""}>
                {t('header.contact')}
              </Nav.Link>

              {/* Services Dropdown */}
              <div className="services-dropdown-container" ref={dropdownRef}>
                <Button 
                  variant="light" 
                  className={`services-btn ${showServicesDropdown ? 'active' : ''}`}
                  onClick={() => setShowServicesDropdown(!showServicesDropdown)}
                >
                  {t('header.services')}
                </Button>
                
                {showServicesDropdown && (
                  <div className="services-dropdown">
                    <div 
                      className={`services-dropdown-item ${selectedService === 'flexible' ? 'active' : ''}`}
                      onClick={() => setSelectedService('flexible')}
                    >
                      {t('header.servicesDropdown.flexibleWorkstations')}
                    </div>
                    <div 
                      className={`services-dropdown-item ${selectedService === 'private' ? 'active' : ''}`}
                      onClick={() => setSelectedService('private')}
                    >
                      {t('header.servicesDropdown.privateOffices')}
                    </div>
                    <div 
                      className={`services-dropdown-item ${selectedService === 'meeting' ? 'active' : ''}`}
                      onClick={() => setSelectedService('meeting')}
                    >
                      {t('header.servicesDropdown.meetingRooms')}
                    </div>
                    <div 
                      className={`services-dropdown-item ${selectedService === 'common' ? 'active' : ''}`}
                      onClick={() => setSelectedService('common')}
                    >
                      {t('header.servicesDropdown.commonSpaces')}
                    </div>
                  </div>
                )}
              </div>

              {/* Language Switcher - Hidden on mobile */}
              {!isMobile && (
                <Dropdown className="language-dropdown">
                  <Dropdown.Toggle variant="link" className="language-toggle">
                    {language.toUpperCase()}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item 
                      onClick={() => language !== 'fr' && toggleLanguage()}
                      active={language === 'fr'}
                    >
                      🇫🇷 Français
                    </Dropdown.Item>
                    <Dropdown.Item 
                      onClick={() => language !== 'en' && toggleLanguage()}
                      active={language === 'en'}
                    >
                      🇬🇧 English
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
}
